export const MIN_PASSWORD_LENGTH = 8

export const validatePassword = (password: string): { isValid: boolean; errorMessage: string } => {
    if (password.length < MIN_PASSWORD_LENGTH) {
        return { isValid: false, errorMessage: `Password must be at least ${MIN_PASSWORD_LENGTH} characters long` }
    }
    if (/\s/.test(password)) {
        return { isValid: false, errorMessage: 'Password must not contain spaces' }
    }
    return { isValid: true, errorMessage: '' }
}
